import { getFromLS, saveInLS, TASKS_LS_KEY } from './local-storage-api';
import { renderTasks } from './render-tasks';

let tasks = getFromLS(TASKS_LS_KEY) || [];

export function addTask(task) {
  tasks.push(task);
  renderTasks(tasks);
  saveInLS(TASKS_LS_KEY, tasks);
}

export function initTasks() {
  renderTasks(tasks);
}

export function deleteTasks(taskTitle) {
  tasks = tasks.filter(task => task.title !== taskTitle);
  renderTasks(tasks);
  saveInLS(TASKS_LS_KEY, tasks);
}
